import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './languages/en.json'
import fr from './languages/fr.json'
import de from './languages/de.json'
import ru from './languages/ru.json'
import ar from './languages/ar.json'
import tr from './languages/tr.json'
import nl from './languages/nl.json'
import menu from '@/components/app/user/partials/navbar/menu.json'

Vue.use(VueI18n)
let userLang = window.navigator.language || window.navigator.userLanguage
let localLang = userLang.split('-')
let locale = localLang[0] || 'en'

const messages = { en, ar, fr, ru, de, tr, nl }

var languageId = 2
if (localStorage.getItem('languageId')) {
	languageId = localStorage.getItem('languageId')
}
var languageCode = 'tr'
if (languageId === 3) languageCode = 'en'
else if (languageId === 4) languageCode = 'fr'
else if (languageId === 7) languageCode = 'de'
else if (languageId === 12) languageCode = 'nl'

locale = languageCode

export default new VueI18n({
	locale,
	messages,
	fallbackLocale: 'en',
	menu
})



// WEBPACK FOOTER //
// ./src/i18n/index.js